module.exports = __webpack_public_path__ + "static/homepage-background1-dab89cecb2b419225c2b04ae0421fbad.jpg";